import {addBusinessDays, format} from 'date-fns';

const getNextWorkingDay = () =>
  format(addBusinessDays(new Date(), 1), 'dd.MM.yyyy');
export default getNextWorkingDay;
